// extracted by mini-css-extract-plugin
module.exports = {"name":"formatters_name__jlfqr","totalPrice":"formatters_totalPrice__2WNF1"};